module.exports = __webpack_public_path__ + "static/media/yoga.b7f050e4.jpg";